import { render, staticRenderFns } from "./update-customer.vue?vue&type=template&id=6417fd3a&"
import script from "./update-customer.vue?vue&type=script&lang=ts&"
export * from "./update-customer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports